import React, { useEffect, useState } from "react"
import { motion } from "framer-motion"
import { cn } from "../../lib/utils"

export function NavBar({ items, activeTab, onTabChange, className }) {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <div
      className={cn(
        "fixed bottom-4 md:bottom-auto md:top-0 left-1/2 -translate-x-1/2 z-50 md:pt-6",
        className,
      )}
    >
      <div className="flex items-center gap-3 bg-black/90 border border-white/10 backdrop-blur-lg py-2 px-2 rounded-full shadow-2xl">
        {items.map((item) => {
          const Icon = item.icon
          const isActive = activeTab === item.url

          return (
            <button
              key={item.name}
              onClick={() => onTabChange(item.url)}
              className={cn(
                "relative cursor-pointer text-sm font-semibold px-4 py-2 rounded-full transition-colors flex items-center justify-center",
                "text-white/80 hover:text-nebula-gold",
                isActive && "bg-white/10 text-nebula-gold",
              )}
            >
              <span className="hidden md:inline">{item.name}</span>
              
              <div className="md:hidden flex flex-col items-center justify-center gap-0.5 min-w-[40px]">
                <Icon size={20} strokeWidth={2.5} />
                <span className="text-[10px] font-medium leading-none mt-1">{item.name}</span>
              </div>

              {isActive && (
                <motion.div
                  layoutId="lamp"
                  className="absolute inset-0 w-full bg-nebula-gold/5 rounded-full -z-10"
                  initial={false}
                  transition={{
                    type: "spring",
                    stiffness: 300,
                    damping: 30,
                  }}
                >
                  <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-8 h-1 bg-nebula-gold rounded-t-full">
                    <div className="absolute w-12 h-6 bg-nebula-gold/20 rounded-full blur-md -top-2 -left-2" />
                    <div className="absolute w-8 h-6 bg-nebula-gold/20 rounded-full blur-md -top-1" />
                    <div className="absolute w-4 h-4 bg-nebula-gold/20 rounded-full blur-sm top-0 left-2" />
                  </div>
                </motion.div>
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}
